import { render, staticRenderFns } from "./SalesmanDetail.vue?vue&type=template&id=c77470b8&scoped=true&"
import script from "./SalesmanDetail.vue?vue&type=script&lang=js&"
export * from "./SalesmanDetail.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanDetail.vue?vue&type=style&index=0&id=c77470b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77470b8",
  null
  
)

export default component.exports